/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_Skill_Group_CountInputs */

const en_tables_pause_reasons_skill_group_count = /** @type {(inputs: Tables_Pause_Reasons_Skill_Group_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons Skill Group Count`)
};

const de_tables_pause_reasons_skill_group_count = /** @type {(inputs: Tables_Pause_Reasons_Skill_Group_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Skill-Gruppen`)
};

/**
* | output |
* | --- |
* | "Reasons Skill Group Count" |
*
* @param {Tables_Pause_Reasons_Skill_Group_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_skill_group_count = /** @type {((inputs?: Tables_Pause_Reasons_Skill_Group_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_Skill_Group_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_skill_group_count(inputs)
	return de_tables_pause_reasons_skill_group_count(inputs)
});